
/* ============================================================================
  PooPooStyle Live Inventory Re-Sorter (Debut)
  Silently moves sold out products to the end of the collection grid dynamically.
============================================================================== */
document.addEventListener("DOMContentLoaded", function() {
  function reprioritizeSoldOut() {
    // Select the product grid container in Debut
    const grid = document.querySelector('.grid--view-items, [id*="Collection"] .grid, .grid-uniform');
    if (!grid) return;
    
    // Convert children to a real array
    const items = Array.from(grid.children);
    if (!items.length) return;
    
    // Separate into available and sold_out
    const available = [];
    const soldOut = [];
    
    items.forEach(item => {
      const text = item.textContent.toUpperCase();
      // Check for sold-out indicators
      if (text.includes("SOLD OUT") || text.includes("UITVERKOCHT") || item.querySelector('.price--sold-out')) {
        soldOut.push(item);
      } else {
        available.push(item);
      }
    });
    
    // Clear and append in correct order
    grid.innerHTML = "";
    available.forEach(el => grid.appendChild(el));
    soldOut.forEach(el => grid.appendChild(el));
  }
  
  // Run once immediately
  reprioritizeSoldOut();
  // Safe timeout fallback in case of dynamic lazy-loading
  setTimeout(reprioritizeSoldOut, 500);
  setTimeout(reprioritizeSoldOut, 1500);
});
